import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import callAPI from '../../../old/api';

export const getAll = createAsyncThunk('enterprise/getAll', async () => {
  console.log('getAll');
  const { data } = await callAPI({ method: 'GET', url: `enterprises` });
  return data;
});

const INITIAL_STATE: any = [];

export const slice = createSlice({
  name: 'ventures',
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: {
    [`${getAll.fulfilled}`]: (state: any, { payload }: any) => {
      return payload;
    },
  },
});

export default slice.reducer;
